/**
 * GIWAHS Adaptive Journey — Resolution & Activation Errors (AJIP-16.02.006 · WS14)
 * ---------------------------------------------------------------------
 * Typed error hierarchy. Every failure path inside the Resolution &
 * Activation Framework throws (or returns) one of these classes.
 *
 * Every subclass extends the Core Engine's JourneyError so consumers
 * can catch resolution/activation faults with a single filter.
 *
 * Governance
 *   * Raw `Error` is prohibited.
 *   * Details payloads never include secrets, credentials, provider
 *     session objects, or unauthorised PII.
 *   * Errors are deterministic — same input produces the same class.
 */
import { JourneyError } from '../core/JourneyErrors';

class ResolutionError extends JourneyError {}
class InvalidResolutionRequestError extends ResolutionError {}
class JourneyNotFoundError extends ResolutionError {}
class UnsupportedJourneyVersionError extends ResolutionError {}
class DeprecatedJourneyError extends ResolutionError {}
class EligibilityRejectedError extends ResolutionError {}
class PermissionDeniedError extends ResolutionError {}
class MissingPrerequisiteError extends ResolutionError {}
class ActivationConflictError extends ResolutionError {}
class DuplicateActivationError extends ResolutionError {}
class InvalidActivationDecisionError extends ResolutionError {}
class OwnershipMismatchError extends ResolutionError {}
class PersistenceRestorationFailureError extends ResolutionError {}
class CoreEngineUnavailableError extends ResolutionError {}
class InvalidJourneyCommandError extends ResolutionError {}
class ActivationAuthorisationError extends ResolutionError {}
class ProtectedComponentViolationError extends ResolutionError {}

const RESOLUTION_ACTIVATION_ERROR_TYPES = Object.freeze([
  'ResolutionError',
  'InvalidResolutionRequestError',
  'JourneyNotFoundError',
  'UnsupportedJourneyVersionError',
  'DeprecatedJourneyError',
  'EligibilityRejectedError',
  'PermissionDeniedError',
  'MissingPrerequisiteError',
  'ActivationConflictError',
  'DuplicateActivationError',
  'InvalidActivationDecisionError',
  'OwnershipMismatchError',
  'PersistenceRestorationFailureError',
  'CoreEngineUnavailableError',
  'InvalidJourneyCommandError',
  'ActivationAuthorisationError',
  'ProtectedComponentViolationError',
]);

export {
  ResolutionError,
  InvalidResolutionRequestError,
  JourneyNotFoundError,
  UnsupportedJourneyVersionError,
  DeprecatedJourneyError,
  EligibilityRejectedError,
  PermissionDeniedError,
  MissingPrerequisiteError,
  ActivationConflictError,
  DuplicateActivationError,
  InvalidActivationDecisionError,
  OwnershipMismatchError,
  PersistenceRestorationFailureError,
  CoreEngineUnavailableError,
  InvalidJourneyCommandError,
  ActivationAuthorisationError,
  ProtectedComponentViolationError,
  RESOLUTION_ACTIVATION_ERROR_TYPES,
};
